import { Component, OnInit } from '@angular/core';
import { OrganizationsService } from 'src/app/Services/organizations.service';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
    selector: 'app-hotelreservationpermittypes',
    templateUrl: './hotelreservationpermittypes.component.html',
    styleUrls: ['./hotelreservationpermittypes.component.scss'],
    standalone: false
})
export class HotelreservationpermittypesComponent implements OnInit {
  public orgService: OrganizationsService;
  public Subsets: string[] = [];
  public Columns: Datalistviewcolumn[] = [];

  constructor(orgService: OrganizationsService) {
    this.orgService = orgService;
    this.Subsets = ['Active', 'Expired'];
    this.Columns = [
      new Datalistviewcolumn("Name", "Name"),
      new Datalistviewcolumn("Price", "PriceString"),
      new Datalistviewcolumn("Active Start Date", "ActiveStartDateLocalFriendlyString"),
      new Datalistviewcolumn("Active End Date", "ActiveEndDateLocalFriendlyString"),
      new Datalistviewcolumn("Max Active Permits", "MaxActivePermits"),
    ];
  }

  ngOnInit(): void { }
}


